import showProductsDiscount from './_showProductsDiscount';
import GlobalStoreHelper from '../../modules/StorePickup/GlobalStoreHelper';

/**
 * Check if variable product_hidden_price is checked
 * If is checked, add class to body
 */
window.products_hidden_price === 'true' &&
    ((document.body.classList.contains('snize-results-page') || document.body.classList.contains('template-collection'))) &&
    document.body.classList.add('product-hide-out-of-stock');

const express_filter = window.express_filter;

/**
 * Gets the code and nome of current store selected
 */
const getStoreInfo = () => {
    const info = GlobalStoreHelper.getStoreInfo();
    if(!info) return {}
    const code = info.code || info.name.match(/\(([^)]+)\)/)?.[1] || null;
    const name = info.name.replace("MediaMarkt ", "");
    const filter = name.replaceAll(" ", "%20");

    return {code, name, filter}
}

let storeInfo = getStoreInfo();
const availabilityBlockName = "filter_ptag_98d8c3e025fb358513056851d0db6e13";

/**
 * Formalize prices of search list to before rendering
 * @return
 * {boolean} When all prices its formalized
 */
const formalizePrice = (zone) => {
    const formatPrice = (price) => {
        const zeroDecimals = price.includes(".00");

        price = price.replace("€","");
        price = price.replace(",","");
        price = price.replace(".00","");

        price = price.concat(zeroDecimals ? ",- €" : " €");

        return price;
    }

    return new Promise(function (resolve, reject) {
        var els = document.getElementsByClassName(zone === 'preview' ? 'snize-quick-view-price-wrapper' : 'snize-price-list');
        Array.prototype.forEach.call(els, function (el) {

            var priceOld = el.getElementsByClassName("snize-discounted-price")[0];
            var price = el.getElementsByClassName("snize-price")[0];

            const priceAlreadyFormated = JSON.parse(price.dataset.formated || "false");

            if (!price.className.indexOf('active') >= 0) {
                if (priceOld) {
                    price.setAttribute('data-old-price', priceOld.innerHTML.replace(',', '').replace('€', ''));
                }

                if(!priceAlreadyFormated) {
                    const taxEl = document.createElement("span");

                    taxEl.innerHTML = "IGIC Incl.";
                    taxEl.classList.add("price-tax");

                    el.appendChild(taxEl);

                    price.innerHTML = formatPrice(price.innerHTML);

                    if(priceOld) {
                        priceOld.innerHTML = formatPrice(priceOld.innerHTML);
                    }

                    price.setAttribute("data-formated","true");
                }

            }
        });
        resolve(true);
    });
};

/**
 * Print href to pagination of search list
 */
const improvementsPaginationList = () => {

    // Instances
    var path = window.location.pathname,
        search = window.location.search,
        els = document.getElementsByClassName("snize-pagination"),
        elsli = els[0].getElementsByTagName("li");

    Array.prototype.forEach.call(elsli, function (el) {
        var a = el.getElementsByTagName('a');
        if (a.length != 0) {
            search = search.replace(/&page=([0-9])/g, '');
            var page = '&page=' + a[0].rev;
            a[0].href = path + search + page;
        }
    });
};

/**
 * Check when search result if completly loaded
 * @return
 * {boolean} When search list it loaded
 */
const searchResultLoad = () => {
    return new Promise(function (resolve, reject) {
        function check() {
            let widgetE = document.getElementById('widget_disabled_opacity');
            if (widgetE.className.includes('snize-hidden')) {
                resolve(true);
            } else {
                setTimeout(function () {
                    check();
                }, 300);
            }
        }
        check();
    });
};

/**
 * Remove form products URL the link to the collection
 */
const updatedProductUrl = () => {
    $('a.snize-view-link').each(function () {
        $(this).attr('href', $(this).attr('href').replace(window.location.pathname, ''));
    });
}

/**
 * Render BigPricesRC to products prices of search list
 */
const searchListPreviewRenderPrice = () => {

    // Formalize prices
    formalizePrice('preview').then(function (res) {

        // Render Price
        // DONTTOUCHBIGPRICES('.snize-price');
    });
};

/**
 * Agree max value to quantity units of product in the quick view
 */
const previewQuantityMaxValue = (value) => {
    const quantityInput = document.getElementById('snize-quick-view-quantity');
    quantityInput.max = value;
}


/**
 * Render BigPricesRC to products prices of search list
 */
const searchListRenderPrice = () => {

    // Check Searh Result is loaded
    searchResultLoad().then(function (res) {

        // Pagination HREF
        improvementsPaginationList();

        // Formalize prices
        formalizePrice().then(function (res) {

            // Show Product Discount
            if (window.products_discount_label === 'true') showProductsDiscount();
        });

        // Set events to render price in quickview
        searchListAttachEvents('quickview');

        // Set events to change de Grid Mode
        searchListAttachEvents('gridmode');

        // Set events to change filters events
        searchListAttachEvents('order');

        // Updated Product url
        updatedProductUrl();
    });
};

/**
 * Attach events to Search List
 */
const searchListAttachEvents = (event) => {

    // Render list
    if (!event) searchListRenderPrice();

    // Order click action of results
    if (event === 'order' || !event) {
        const mainPanel = $(".snize-search-results");
        const mainModal = $('#snize-modal-mobile-filters-dialog');
        const mobileOrderModal = $('#snize-modal-mobile-sortby-dialog');

        mainModal.find('.needsclick').on('click', function (e) {
            setTimeout(function () {
                searchListRenderPrice();
            }, 500);
        });

        mainModal.find('.snize-product-filters-reset').on('click', function (e) {
            setTimeout(function () {
                searchListRenderPrice();
            }, 500);
        });

        mainModal.find('.snize-product-filters-reset-all').on('click', function (e) {
            setTimeout(function () {
                searchListRenderPrice();
            }, 500);
        });

        mainPanel.find('.snize-product-filters-reset').on('click', function (e) {
            setTimeout(function () {
                searchListRenderPrice();
            }, 500);
        });

        mobileOrderModal.find('.snize-main-panel-dropdown-content').on('click', function (e) {
            setTimeout(function () {
                searchListRenderPrice();
            }, 500);
        });
    }

    // Set click action to filters of results
    if (event === 'filters' || !event) {
        $(".snize-product-filters").click(function () {
            setTimeout(function () {
                searchListRenderPrice();
            }, 300);
        });

        $('.snize-product-filters').on('keypress', function (e) {
            if (e.which == 13) {
                setTimeout(function () {
                    searchListRenderPrice();
                }, 300);
            }
        });

        $(".snize-main-panel").click(function () {
            setTimeout(function () {
                searchListRenderPrice();
            }, 300);
        });
    }

    // Set click action to pagination search result
    if (event === 'pagination' || !event) {
        $(".snize-pagination").click(function () {
            setTimeout(function () {
                searchListRenderPrice();
            }, 300);
        });
    }

    // Set click action to search preview product
    if (event === 'quickview' || !event) {
        $('.snize-quick-view-button').on('click', function (e) {
            setTimeout(function () {
                // Render Prices to preview
                searchListPreviewRenderPrice();

                // Add Quantity max value
                previewQuantityMaxValue(3);
            }, 300);
        });
    }

    if (event === 'gridmode' || !event) {
        $('.snize-grid-mode-icon').off('click').on('click', function (e) {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 500);
        });

        $('.snize-list-mode-icon').off('click').on('click', function (e) {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 500);
        });
    }

    // Render Price if Window Resize
    if (event === 'resize' || !event) {
        window.onresize = function (event) {
            checkExpressFilter("event");
            setTimeout(function () {
                searchListRenderPrice();

                if (window.innerWidth <= 1024) changeModeListToGrid();
            }, 300);
        };
    }

    // Detect Banners Actices
    searchWithBanners();
};

/**
 * Detect if Banner component if active to the collection result
 */
const searchWithBanners = () => {
    const slides = document.querySelectorAll('.splide__slide');
    if (slides.length) document.getElementById('snize_results').classList.add('with_banners');
}

const changeModeListToGrid = () => {
    const gridModeIcon = document.querySelector('.snize-grid-mode-icon');
    const activeGridModeIcon = document.querySelector('.snize-grid-mode-icon.active');

    if (gridModeIcon && !activeGridModeIcon) {
        gridModeIcon.click();
    }
}

const checkExpressFilter = (step) => {
    const search = window.location.search;

    if (step === "init" && search.includes("availability=Express")) {
        return window.location.search = search.replace("availability=Express", `rb_${availabilityBlockName}=${storeInfo.filter}`);
    }

    const availabilityBlock = document.getElementById(`snize_filters_block_${availabilityBlockName}`);

    if (availabilityBlock != null) {
        let expressList = document.querySelectorAll(`#snize_filters_block_${availabilityBlockName} .snize-product-filters-list label > .needsclick`);
        expressList.forEach((item) => {
            if (!item.innerText.includes(storeInfo.name)) {
                item.parentElement.parentElement.remove();
            } else {
                item.childNodes[0].data = `${express_filter} - ${storeInfo.name}`;
            }
        })

        expressList = document.querySelectorAll(`#snize_filters_block_${availabilityBlockName} .snize-product-filters-list label > .needsclick`);

        if (expressList.length == 0) availabilityBlock.remove();
    }
}

const updatePaginationStyle = () => {
    const paginationPrev = document.querySelector("div.snize div.snize-pagination ul li .snize-pagination-prev");
    const paginationNext = document.querySelector("div.snize div.snize-pagination ul li .snize-pagination-next");

    if (paginationPrev !== undefined && paginationPrev !== null) paginationPrev.innerHTML = "← Anterior";
    if (paginationNext !== undefined && paginationNext !== null) paginationNext.innerHTML = "Siguiente →";
}

// Load Ready Execution
$(window).on("load", function () {

    // Instances
    const section = mmkt.core.pathLocation.getSection();

    // Check if sections is a collection or search results
    if (section === 'collections' || section === 'search-results-page') {
        updatePaginationStyle();
        checkExpressFilter("init");

        // Render Prices to search list
        searchListAttachEvents();

        // Updated Product url
        updatedProductUrl();
    }

    //adding width on loaded then it will be based on page with
    if (window.innerWidth <= 1024) {
        changeModeListToGrid();
    } else {
        const gridMode = document.getElementById('snize-search-results-grid-mode');
        const listMode = document.getElementById('snize-search-results-list-mode');
        if (gridMode) {
            gridMode.style.width = 'calc(100% - 245px)';
            window.dispatchEvent(new Event('resize'));
        }
        if (listMode) listMode.style.width = 'calc(100% - 245px)';
    }

    const storeObserver = new MutationObserver(() => {
        window.location.search = window.location.search.replace(`rb_${availabilityBlockName}=${storeInfo.filter}`, "");
    });

    const gridObserver = new MutationObserver(() => {
        checkExpressFilter("event");
    });

    const paginationObserver = new MutationObserver(() => {
        updatePaginationStyle();
    });

    storeObserver.observe(document.querySelector(".subtitle.store-name"), { subtree: false, childList: true });

    gridObserver.observe(document.querySelector(".snize-search-results-content"), { subtree: false, childList: true })

    paginationObserver.observe(document.querySelector("div.snize div.snize-pagination"), { subtree: false, childList: true })
});